<!--  <dp-sub-header-gradient></dp-sub-header-gradient> -->
<!-- <p>teste</p> -->

<!-- <dp-skeleton-page *ngIf="showLoadingArea"></dp-skeleton-page> -->

<!-- <div class="container container--small container--negative" *ngIf="!showLoadingArea"> -->
    <div class="container container--small container--negative">
    <!-- <dp-message-error *ngIf="error"></dp-message-error> -->    
    
    <!-- <div *ngIf="!error"> -->
    <div>
        <!-- <dp-proof-tracking *ngIf="showTracking || openOptin" [status]="openOptin?.status"></dp-proof-tracking> -->
        <dp-proof-tracking></dp-proof-tracking>

        <!-- <div class="dp-proof-of-life" *ngIf="!showTracking && !openOptin"> -->
        <div class="dp-proof-of-life">
            <dp-form-optin></dp-form-optin>
        </div>
        
    </div>
</div>
